import NewActivity from "./NewActivity";
import { Fragment, useEffect, useState } from "react";
import {
  getExercisePerformanceGraph,
  getUserActivities,
  getExerciseCountGraph,
  getCaloriesGraph,
  getMinutesGraph,
} from "../../api/api";
import { Popover, Tab, Transition } from "@headlessui/react";
import { capitalize } from "../../utils/Utils";
import { Icon } from "@iconify/react";
import { toast } from "react-toastify";
import Button from "../basic/Button";
import { useNavigate } from "react-router-dom";
import CanvasBg from "../../assets/images/performancep_hestogram.png";
import brChart from "../../assets/images/bar_chart.png";
import Bar_One from "../../assets/images/Bar_One.png";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  CartesianAxis,
  Tooltip,
  BarChart,
  Bar,
  Label,
  LabelList,
  ResponsiveContainer,
} from "recharts";
import { useAppContext } from "../../context/AppContext";

// EXERCISE COUNT FUNCTION
function ExerciseCountGraph({ data, xAxisKey, yAxisKey }) {
  function CustomTooltip({ payload, label, active }) {
    if (active && payload) {
      return (
        <div
        // className="custom-tooltip p-2 rounded-lg outline-none"
        // style={{
        //     background:
        //         "linear-gradient(180deg, #6C7FE7 0%, rgba(64, 79, 215, 0.56) 97.92%)",
        //     // background: linear-gradient(180deg, #6C7FE7 0%, rgba(64, 79, 215, 0.56) 97.92%);

        // }}
        >
          {/* <p className="text-white  font-bold">Frequency: {payload[0].value}</p>
                    <p className="text-white font-bold">{payload[0].payload[xAxisKey]}</p> */}
        </div>
      );
    }

    return "";
  }

  function formatDate(value) {
    const date = new Date(value);
    return (
      date.toDateString().split(" ")[2] +
      " " +
      date.toDateString().split(" ")[1]
    );
  }

  function CustomXAxisTick({
    x,
    y,
    payload,
    width = 10,
    maxChars = 10,
    lineHeight = 14,
    fontSize = 14,
    fill = "#FFF",
  }) {
    if (!payload.value) return <p></p>;
    const rx = new RegExp(`.{1,${maxChars}}`, "g");
    const chunks = formatDate(payload.value)
      .replace(/-/g, " ")
      .split(" ")
      .map((s) => s.match(rx))
      .flat();
    const tspans = chunks.map((s, i) => (
      <tspan x={0} y={lineHeight} dy={i * lineHeight}>
        {s}
      </tspan>
    ));
    return (
      <g transform={`translate(${x},${y})`}>
        <text
          width={width}
          height="auto"
          textAnchor="middle"
          fontSize={fontSize}
          fill={fill}
          fontWeight={700}
        >
          {tspans}
        </text>
      </g>
    );
  }

  const appState = useAppContext();

  return (
    <ResponsiveContainer width={"100%"} height={350}>
      <BarChart
        data={data}
        margin={{ top: 0, left: 10, right: 20, bottom: 30 }}
      >
        <defs>
          <linearGradient
            id="colorUv"
            x1="0"
            y1="0"
            x2="0"
            y2="100%"
            spreadMethod="reflect"
          >
            <stop offset="%" stopColor="#6C7FE7" stopOpacity={1} />
            <stop offset="95%" stopColor="#404FD7" stopOpacity={0.56} />
            {/* background: linear-gradient(180deg, #6C7FE7 0%, rgba(64, 79, 215, 0.56) 97.92%); */}
          </linearGradient>
        </defs>
        <Bar
          type="monotone"
          dataKey={yAxisKey}
          fill="url(#colorUv)"
          // barSize={45}
          radius={[50, 50, 0, 0]}
          maxBarSize={30}
        >
          {" "}
          <LabelList
            dataKey={yAxisKey}
            position="top"
            className="text-white text-sm font-bold"
            style={{
              textAnchor: "middle",
              fontSize: "14",
              fill: "rgba(255,255,255, 0.9)",
            }}
          />
        </Bar>
        <XAxis
          stroke={appState.state.darkMode ? "#fff" : "#232733"}
          dataKey={xAxisKey}
          tick={<CustomXAxisTick />}
          tickLine={{ stroke: false }}
          interval={0}
          axisLine={false}
          fontSize={12}
          accentHeight={20}
          height={40}
        />
        {/* <Label
                        value="Time"
                        position="bottom"
                        //fill={appState.state.darkMode ? "#fff" : "#232733"}
                        fill='rgba(255,255,255, 0.9)'
                        fontSize={14}
                        fontWeight={700}
                        textAnchor="middle"
                    />
                </XAxis> */}
        <YAxis
          stroke={appState.state.darkMode ? "#fff" : "#232733"}
          axisLine={false}
          tickLine={false}
          // strokeWidth={3}
          allowDecimals={false}
          domain={[0, 50]}
          type="number"
          alignmentBaseline="auto"
        >
          <Label
          // value='Exercises'
          // offset={10}
          // angle={-90}
          // //   fill={appState.state.darkMode ? "#fff" : "#232733"}
          // fill='rgba(255,255,255, 0.9)'
          // fontWeight={700}
          // position="insideLeft"
          // style={{ textAnchor: "middle" }}
          />
        </YAxis>
        <CartesianGrid
          vertical={false}
          horizontal={true}
          strokeDasharray="2 2"
          stroke={appState.state.darkMode ? "#395CD9" : "#fff"}
        />
        <Tooltip content={<CustomTooltip />} cursor={false} />
      </BarChart>
    </ResponsiveContainer>
  );
}

// CALORIES BURNT FUNCTION
function CaloriesCountGraph({ data, xAxisKey, yAxisKey }) {
  function CustomTooltip({ payload, label, active }) {
    if (active && payload) {
      return (
        // <div
        //     className="custom-tooltip p-2 rounded-lg outline-none"
        //     style={{
        //         background:
        //             "linear-gradient(178.95deg, #3E0CA7 5.08%, #0B28AC 100%)",
        //     }}
        // >
        //     <p className="text-white  font-bold">Frequency: {payload[0].value}</p>
        //     <p className="text-white font-bold">{payload[0].payload[xAxisKey]}</p>
        // </div>
        <div></div>
      );
    }

    return "";
  }

  function formatDate(value) {
    const date = new Date(value);
    return (
      date.toDateString().split(" ")[2] +
      " " +
      date.toDateString().split(" ")[1]
    );
  }

  function CustomXAxisTick({
    x,
    y,
    payload,
    width = 10,
    maxChars = 10,
    lineHeight = 14,
    fontSize = 14,
    fill = "#FFF",
  }) {
    if (!payload.value) return <p></p>;
    const rx = new RegExp(`.{1,${maxChars}}`, "g");
    const chunks = formatDate(payload.value)
      .replace(/-/g, " ")
      .split(" ")
      .map((s) => s.match(rx))
      .flat();
    const tspans = chunks.map((s, i) => (
      <tspan x={0} y={lineHeight} dy={i * lineHeight}>
        {s}
      </tspan>
    ));
    return (
      <g transform={`translate(${x},${y})`}>
        <text
          width={width}
          height="auto"
          textAnchor="middle"
          fontSize={fontSize}
          fill={fill}
          fontWeight={700}
        >
          {tspans}
        </text>
      </g>
    );
  }

  const appState = useAppContext();

  return (
    <ResponsiveContainer width={"100%"} height={350}>
      <LineChart
        data={data}
        margin={{ top: 0, left: 10, right: 20, bottom: 30 }}
      >
        <Line
          // type="monotone"
          dataKey={yAxisKey}
          // strokeLinecap="round"
          strokeWidth={3}
          dot={false}
          stroke="#F05A3D"
        >
          {" "}
          <LabelList
            dataKey={yAxisKey}
            position="top"
            className="text-white text-sm font-bold"
            style={{
              textAnchor: "middle",
              fontSize: "14",
              fill: "rgba(255,255,255, 0.9)",
            }}
          />
        </Line>
        <XAxis
          stroke={appState.state.darkMode ? "#fff" : "#232733"}
          dataKey={xAxisKey}
          axisLine={false}
          tick={<CustomXAxisTick />}
          tickFormatter={formatDate}
        />
        <YAxis
          stroke={appState.state.darkMode ? "#fff" : "#232733"}
          axisLine={false}
          allowDecimals={false}
          // domain={[0, 50]}
        />
        <CartesianAxis
          axisLine={false}
          fill={appState.state.darkMode ? "#fff" : "#232733"}
        />
        <CartesianGrid
          vertical={false}
          strokeDasharray="2 2"
          stroke={appState.state.darkMode ? "#D93942" : "#fff"}
        />
        <Tooltip content={<CustomTooltip />} />
      </LineChart>
    </ResponsiveContainer>
  );
}

// MINUTES COUNT FUNCTION
function MinutesCountGraph({ data, xAxisKey, yAxisKey }) {
  function CustomTooltip({ payload, label, active }) {
    if (active && payload) {
      return <div></div>;
    }

    return "";
  }

  function formatDate(value) {
    const date = new Date(value);
    return (
      date.toDateString().split(" ")[2] +
      " " +
      date.toDateString().split(" ")[1]
    );
  }

  function CustomXAxisTick({
    x,
    y,
    payload,
    width = 10,
    maxChars = 10,
    lineHeight = 14,
    fontSize = 14,
    fill = "#FFF",
  }) {
    if (!payload.value) return <p></p>;
    const rx = new RegExp(`.{1,${maxChars}}`, "g");
    const chunks = formatDate(payload.value)
      .replace(/-/g, " ")
      .split(" ")
      .map((s) => s.match(rx))
      .flat();
    const tspans = chunks.map((s, i) => (
      <tspan x={0} y={lineHeight} dy={i * lineHeight}>
        {s}
      </tspan>
    ));
    return (
      <g transform={`translate(${x},${y})`}>
        <text
          width={width}
          height="auto"
          textAnchor="middle"
          fontSize={fontSize}
          fill={fill}
          fontWeight={700}
        >
          {tspans}
        </text>
      </g>
    );
  }

  const appState = useAppContext();

  return (
    <ResponsiveContainer width={"100%"} height={350}>
      <BarChart
        data={data}
        margin={{ top: 0, left: 10, right: 20, bottom: 30 }}
      >
        <defs>
          <linearGradient
            id="colorUv"
            x1="0"
            y1="0"
            x2="0"
            y2="100%"
            spreadMethod="reflect"
          >
            <stop offset="5%" stopColor="#6C39D9" stopOpacity={0.9} />
            <stop offset="95%" stopColor="6C39D9" stopOpacity={0.1} />
          </linearGradient>
        </defs>
        <Bar
          dataKey={yAxisKey}
          fill="url(#colorUv)"
          radius={[50, 50, 0, 0]}
          maxBarSize={30}
        >
          <LabelList
            dataKey={yAxisKey}
            position="top"
            className="text-white text-sm font-bold"
            style={{
              textAnchor: "middle",
              fontSize: "14",
              fill: "rgba(255,255,255, 0.9)",
            }}
          />
        </Bar>
        <XAxis
          stroke={appState.state.darkMode ? "#fff" : "#232733"}
          dataKey={xAxisKey}
          tick={<CustomXAxisTick />}
          tickLine={{ stroke: false }}
          interval={0}
          axisLine={false}
          fontSize={12}
          accentHeight={20}
          height={40}
        />
        <YAxis
          stroke={appState.state.darkMode ? "#fff" : "#232733"}
          axisLine={false}
          tickLine={false}
          // strokeWidth={3}
          allowDecimals={false}
          domain={[0, 20]}
          type="number"
          alignmentBaseline="auto"
        />
        <CartesianGrid
          vertical={false}
          horizontal={true}
          strokeDasharray="2 2"
          stroke={appState.state.darkMode ? "#395CD9" : "#fff"}
        />
        <Tooltip content={<CustomTooltip />} cursor={false} />
      </BarChart>
    </ResponsiveContainer>
  );
}

function NewPerformance() {
  const [perfomanceData, setPerformanceData] = useState([]);
  const [userActivity, setUserActivity] = useState({});
  const [accuracyRange, setAccuracyRange] = useState("week");
  const [exerciseCount, setExerciseCount] = useState([]);
  const [minutesCount, setMinutesCount] = useState([]);
  const [caloriesBurnt, setCaloriesBurnt] = useState([]);
  const navigate = useNavigate();

  async function updatePerformanceData() {
    let response = await getExercisePerformanceGraph();
    setPerformanceData(response);
  }

  // EXERCISE COUNT FUNCTION
  async function updateExerciseData() {
    let response = await getExerciseCountGraph(accuracyRange);
    console.log("Performance Count Graph : " + response);
    if (response) {
      let updatedResponse = [];
      response.forEach((data) => {
        if (data.exerciseDone == 0) {
          updatedResponse.push({
            exerciseDone: data.exerciseDone + 1,
            doneON: data.doneON,
          });
        } else {
          updatedResponse.push(data);
        }
      });
      console.log(response);
      setExerciseCount(updatedResponse);
    } else toast("Unable to fetch accuracy data", { type: "error" });
  }

  // CALORIES BURNT FUNCTION
  async function caloriesBurntData() {
    let response = await getCaloriesGraph(accuracyRange);
    console.log("Burnt Calorie :" + response.doneON);
    // console.log(response);
    if (response) {
      let updatedResponse = [];
      response.forEach((data) => {
        if (data.calories == 0) {
          updatedResponse.push({
            calories: data.calories + 1,
            doneON: data.doneON,
          });
        } else {
          updatedResponse.push(data);
        }
      });
      setCaloriesBurnt(updatedResponse);
    } else toast("Unable to fetch minutes/time data", { type: "error" });
  }

  // Minutes Count Function
  async function updateMinutesData() {
    let response = await getMinutesGraph(accuracyRange);
    if (response) {
      let updatedResponse = [];
      response.forEach((data) => {
        if (data.timeDone == 0) {
          updatedResponse.push({
            timeDone: data.timeDone + 1,
            doneON: data.doneON,
          });
          // console.log(timeDone);
          // console.log(DoneOn);
        } else {
          updatedResponse.push(data);
        }
      });
      setMinutesCount(updatedResponse);
    } else toast("Unable to fetch minutes/time data", { type: "error" });
  }

  //  ACTIVITY FUNCTION
  async function updateActivites() {
    let response = await getUserActivities();
    if (response) setUserActivity(response);
    else toast("Unable to fetch your activites", { type: "error" });
  }

  useEffect(() => {
    updatePerformanceData();
    updateActivites();
    updateExerciseData();
    updateMinutesData();
    caloriesBurntData();
  }, []);

  useEffect(() => {
    updateExerciseData();
    caloriesBurntData();
    updateMinutesData();
  }, [accuracyRange]);

  return (
    <div
      className={`w-full h-full flex flex-1 py-5 md:py-8 px-5 md:px-28 bg-[#0E0E11]`}
    >
      <div className="w-full h-full lg:px-2 md:py-10 px-0">
        <Tab.Group>
          <Tab.List className="flex space-x-16 h-16 w-full lg:px-32 px-5 overflow-auto">
            <Tab
              className={({ selected }) =>
                `${
                  selected
                    ? "border-b-4  text-primary-blue border-primary-blue dark:text-primary-neonGreen dark:border-primary-neonGreen   "
                    : "text-primary-lightBlue dark:text-primary-white"
                } h-full space-x-3 flex items-center justtify-center text-xl md:text-2xl font-bold `
              }
            >
              Activities
            </Tab>
            <Tab
              className={({ selected }) =>
                `${
                  selected
                    ? "border-b-4  text-primary-blue border-primary-blue dark:text-primary-neonGreen dark:border-primary-neonGreen   "
                    : "text-primary-lightBlue dark:text-primary-white"
                } h-full space-x-3 flex items-center justtify-center text-xl md:text-2xl font-bold`
              }
            >
              Progress
            </Tab>
          </Tab.List>
          <Tab.Panels className="py-10 ">
            <Tab.Panel>
              <div className="px-4 md:px-28">
                <NewActivity timeline={userActivity} />
              </div>
            </Tab.Panel>
            <Tab.Panel>
              <div className="flex flex-col space-y-12 mt-5 md:px-28">
                <Popover
                  className={
                    "relative flex justify-end right-3 lg:-mt-12 -mt-10 lg:mb-6 mb-3"
                  }
                >
                  <Popover.Button
                    className={`flex justify-end items-center flex-row bg-transparent outline outline-1 outline-white rounded-md px-5 py-1`}
                  >
                    <p className="flex justify-end items-center text-primary-white font-medium lg:text-md text-sm uppercase">
                      {capitalize(accuracyRange)}
                    </p>
                    <Icon
                      icon={"akar-icons:chevron-down"}
                      className="flex justify-center items-center text-primary-white"
                    />
                  </Popover.Button>
                  <Transition
                    as={Fragment}
                    enter="transition ease-out duration-150"
                    enterFrom="opacity-0 translate-y-0"
                    enterTo="opacity-100 translate-y-1"
                    leave="transition ease-in duration-150"
                    leaveFrom="opacity-100 translate-y-1"
                    leaveTo="opacity-0 translate-y-0"
                  >
                    <Popover.Panel
                      className={`absolute w-20 p-4 space-y-2 flex flex-col bg-[#1F1F1F] rounded-lg text-white`}
                    >
                      {({ close }) => (
                        <>
                          <p
                            className="font-medium cursor-pointer"
                            onClick={() => {
                              setAccuracyRange("week");
                              close();
                            }}
                          >
                            Week
                          </p>
                          <p
                            className="font-medium cursor-pointer"
                            onClick={() => {
                              setAccuracyRange("month");
                              close();
                            }}
                          >
                            Month
                          </p>
                        </>
                      )}
                    </Popover.Panel>
                  </Transition>
                </Popover>
                <div
                  // className="flex flex-col col-span-1 h-full min-h-[350px] p-3 rounded-xl"
                  className="lg:px-10 px-4 lg:py-10 py-4 rounded-xl"
                  style={{
                    backgroundImage: `url(${Bar_One})`,
                    backgroundSize: "cover",
                  }}
                >
                  <p className="flex justify-start mx-10 lg:mb-6 mb-3 text-white lg:text-2xl text-xl font-bold">
                    Exercises
                  </p>
                  {exerciseCount.length == 0 ? (
                    <Button
                      className={`text-md`}
                      type={"primary"}
                      onClick={() => {
                        navigate("/practice");
                      }}
                    >
                      Do more exercises to get analytics
                    </Button>
                  ) : (
                    <ExerciseCountGraph
                      data={exerciseCount}
                      xAxisKey="date"
                      yAxisKey="freuqency"
                    />
                  )}
                </div>

                <div
                  className="lg:px-10 px-4 lg:py-10 py-4 rounded-xl"
                  style={{
                    backgroundImage: `url(${CanvasBg})`,
                    backgroundSize: "cover",
                    color: "green",
                  }}
                >
                  <p className="flex justify-start mx-10 lg:mb-6 mb-3 text-white lg:text-2xl text-xl font-bold">
                    Calories Burnt
                  </p>
                  {/*  */}
                  {caloriesBurnt.length == 0 ? (
                    <Button
                      className={`text-md`}
                      type={"primary"}
                      onClick={() => {
                        navigate("/practice");
                      }}
                    >
                      Do more exercises to get analytics
                    </Button>
                  ) : (
                    <CaloriesCountGraph
                      data={caloriesBurnt}
                      xAxisKey="doneON"
                      yAxisKey="calories"
                    />
                  )}
                </div>
                <div
                  className="lg:px-10 px-4 lg:py-10 py-4 rounded-xl"
                  style={{
                    backgroundImage: `url(${brChart})`,
                    backgroundSize: "cover",
                  }}
                >
                  <p className="flex justify-start mx-10 lg:mb-6 mb-3 text-white lg:text-2xl text-xl font-bold">
                    Minutes
                  </p>
                  {minutesCount.length == 0 ? (
                    <Button
                      className={`text-md`}
                      type={"primary"}
                      onClick={() => {
                        navigate("/practice");
                      }}
                    >
                      Do more exercises to get analytics
                    </Button>
                  ) : (
                    <MinutesCountGraph
                      data={minutesCount}
                      xAxisKey="doneON"
                      yAxisKey="timeDone"
                    />
                  )}
                </div>
              </div>
            </Tab.Panel>
          </Tab.Panels>
        </Tab.Group>
      </div>
    </div>
  );
}
export default NewPerformance;
